import '.n{width:100%;}.ssr-plugin'
import '.gv{background-color:lightgray;}.ssr-plugin'
import '.gw{background-size:100px 100px, auto;}.ssr-plugin'
import '.gx{background-repeat:repeat, no-repeat;}.ssr-plugin'
import '.gy{background-position:0% 0%, 0% 0%;}.ssr-plugin'
import '.gz{background-blend-mode:overlay, normal;}.ssr-plugin'
import '.a{display:grid;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.h0{border-radius:var(--border-radius-image);}.ssr-plugin'
import '.h1{padding:3.5rem 2rem;}.ssr-plugin'
import '.be{text-align:center;}.ssr-plugin'
import '.az{height:100%;}.ssr-plugin'
import '.h2{width:12.5rem;}.ssr-plugin'
import '.h3{grid-template-rows:auto 1fr auto;}.ssr-plugin'
import '.b0{flex:1;}.ssr-plugin'
import '.an{justify-content:center;}.ssr-plugin'
import '.h4{padding:0.75rem 0;}.ssr-plugin'
import FreddieImage from '@app/assets/images/about-us/team/Freddie.jpg'
import SaschaImage from '@app/assets/images/about-us/team/Sascha-two.jpg'
import { Button } from '@app/components/core/button/Button'
import { Image } from '@app/components/core/image/Image'
import { Paragraph } from '@app/components/core/typography/Paragraph'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import contactCardTexture from '@app/assets/images/background-contact-card.png'
import { type Style, styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'

type ContactPerson = {
  imageSrc: string
  imageAlt: string
  name: string
  role: string
  link: string
}

export type ContactCardProps = {
  style?: Style
}

export const ContactCard = ({ style }: ContactCardProps) => {
  const isMobile = useMediaQuery()
  const t = useTranslations()

  const CONTACT_PEOPLE: ContactPerson[] = [
    {
      imageSrc: SaschaImage,
      imageAlt: 'Portrait of Sascha Glasl',
      name: 'Sascha \nGlasl',
      role: t.app.forMunicipalities.contact.people.sascha.role,
      link: 'https://meetings-eu1.hubspot.com/sascha-glasl',
    },
    {
      imageSrc: FreddieImage,
      imageAlt: 'Portrait of Freddie Aldershoff',
      name: 'Freddie Aldershoff',
      role: t.app.forMunicipalities.contact.people.freddie.role,
      link: 'https://meetings-eu1.hubspot.com/freddie-aldershoff/freddie-demo',
    },
  ]

  return (
    <styled.div className="n gv gw gx gy gz"
      style={{
        backgroundImage: `url(${contactCardTexture}), linear-gradient(177deg, #FFF 13.41%, #FBEBD1 66.89%, #FFCB93 93.89%, #F1A782 115.68%)`,
        borderRadius: isMobile ? '0.5rem' : '3rem',
        padding: isMobile ? '0.5rem' : '4.5rem',
        ...style,
      }}
    >
      <div className="a r"
        style={{
          gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 1fr) auto',
          gap: isMobile ? '2rem' : '9rem',}}
      >
        <styled.div>
          <Title.H2>{t.app.forMunicipalities.contact.title}</Title.H2>
          <Paragraph.Medium>
            {t.app.forMunicipalities.contact.description}
          </Paragraph.Medium>
        </styled.div>

        <div className="n a g"
          style={{
            gridTemplateColumns: isMobile
              ? '1fr'
              : 'repeat(2, minmax(13rem, 1fr))',}}
        >
          {CONTACT_PEOPLE.map((person) => (
            <div className="d e t h0 h1 r be az"
              key={person.name}
            >
              <Image
                src={person.imageSrc}
                alt={person.imageAlt}
                resizeWidth={144}
                style={{
                  width: '9rem',
                  height: '9rem',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  marginBottom: '0.75rem',
                }}
              />
              <div className="h2 a h3 az b0"
              >
                <Title.H4
                  style={{
                    whiteSpace: 'pre-line',
                    marginBottom: 0,
                  }}
                >
                  {person.name}
                </Title.H4>
                <div className="d r an be h4"
                >
                  <Paragraph.Medium
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    {person.role}
                  </Paragraph.Medium>
                </div>
                <Button
                  size="medium"
                  variant="primary"
                  label={t.app.forMunicipalities.contact.buttonLabel}
                  to={person.link}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </styled.div>
  )
}
